import { computed } from "vue";
import { BlockDef } from "./block.interfaces";
import { buttonField, createBlock, textField } from "./blockBuilder";
import { useDefaultColors } from "./useDefaultColors";
import { WithButton, WithButtonProps } from "@/views/blocks/banner/banner";

export function useBanners() {
    const { colorDefaults } = useDefaultColors();

    const withButtonBlock = computed<BlockDef>(() =>
        createBlock<WithButtonProps>({
            typeId: "WithButton",
            type: "banner",
            name: "Banner with button",
            component: WithButton,
        })
            .withField("title", textField("Title", "Special Announcement"))
            .withField(
                "description",
                textField("Description", "Check out our latest features and updates!")
            )
            .withField(
                "button",
                buttonField("Button", {
                    label: "Learn More",
                    href: "#",
                })
            )
            .withStyleFields([
                colorDefaults.value.background,
                colorDefaults.value.text,
                colorDefaults.value.brand,
            ])
            .build()
    );

    return {
        blocks: computed(() => [withButtonBlock.value]),
    };
}
